const getFieldType = ({
  datasets,
  datasetType,
  fieldName,
}: {
  datasets: FleetOps.DatasetDefinition[];
  datasetType: string;
  fieldName: string;
}): FleetOps.FieldType | undefined => {
  const dataset = datasets.find((d) => d.type === datasetType);
  if (!dataset) return undefined;
  const field = dataset.fields.find((f) => f.field === fieldName);
  return field?.type;
};

export default getFieldType;
